
import { createApp } from 'vue';
import './style.css';
import App from './App.vue';
import router from './router';
import { DefaultApolloClient } from '@vue/apollo-composable';
import apolloClient, { setAuthToken } from './lib/apollo';
import { setAdminAuthToken } from './lib/apollo-admin';
import { setPaymentAuthToken } from './lib/apollo-payment';
import { setDeliveryAuthToken } from './lib/apollo-delivery';
import './lib/microfrontend-auth-handler.js';

// Configurar la comunicación con el frontend padre
declare global {
    interface Window {
        microfrontendAuth: any;
    }
}

const app = createApp(App);
app.use(router);
app.provide(DefaultApolloClient, apolloClient);

// Configurar callback para cuando se reciba el token
window.microfrontendAuth.onTokenReceived((token: string, _user: any) => {
    // Actualizar todos los Apollo Clients con el nuevo token
    setAuthToken(token);
    setAdminAuthToken(token);
    setPaymentAuthToken(token);
    setDeliveryAuthToken(token);
});

// Intentar solicitar token al frontend padre inmediatamente si no se recibe
try {
    if (!window.microfrontendAuth.hasToken()) {
        window.microfrontendAuth.requestToken();
    }
} catch (e) {
    if (import.meta.env.DEV) {
        console.warn('⚠️ microfrontendAuth not available in this context', e);
    }
}

app.mount('#app');
